import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../../stores/root-store-context';
import type { IUser } from '../../model/user';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

interface useUsersResult {
    isLoaded: boolean;
    users: IUser[] | null;
}

export const useUsers = (callbackTrigger: number) => {

    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();

    const [result, setResult] = useState(() => ({
        isLoaded: true,
        users: []
    } as useUsersResult));

    useEffect(() => {

        setResult({ isLoaded: false, users: [] });

        rootStore.usersStore.loadUsers()
            .then(() => {
                setResult({ isLoaded: true, users: rootStore.usersStore.users });
            })
            .catch(e => {
                    console.log(e);
                    publishNotification({
                        text: 'Error Loading Users',
                        canClose: true
                    });
                }
            );
    }, [publishNotification, rootStore.userStore, callbackTrigger]);

    return result;
};
